import React from 'react';
import Landing from './views/examples/Landing'

const Home = () => (
    <div className='home'>
      <Landing></Landing>
    </div>
);

export default Home;